import { Fragment } from "react";
import { DashedCard } from "../ui/DashedCard";
import type { Recipe } from "../data/automations";

export function RecipeCard({ recipe }: { recipe: Recipe }) {
  return (
    <DashedCard hover={false} className="p-[18px]">
      <div className="flex justify-between items-start gap-3 mb-2">
        <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-accent border border-dashed border-accent rounded-full px-2 py-0.5 shrink-0">
          {recipe.tag}
        </span>
        <div className="flex flex-wrap justify-end items-center gap-1">
          {recipe.uses.map((tool, i) => (
            <Fragment key={tool}>
              {i > 0 && <span className="text-[10px] text-td-3"> · </span>}
              <span className="font-mono text-[10px] tracking-wide text-td-3">
                {tool}
              </span>
            </Fragment>
          ))}
        </div>
      </div>
      <p className="text-sm italic leading-snug text-td-1">{recipe.text}</p>
    </DashedCard>
  );
}
